// removed by extract-text-webpack-plugin
module.exports = {"root":"SportappNonLoggedBG__root___37M2j"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/sportapp/components/NonLoggedBG/SportappNonLoggedBG.scss
// module id = 2233
// module chunks = 0